import React from "react";
import {
  FileText,
  Video,
  Mic,
  ExternalLink,
  Layers,
  Users,
  Newspaper,
} from "lucide-react";

export function getResourceIcon(
  resourceType: string | null | undefined,
): React.ReactNode {
  const type = resourceType?.toLowerCase();

  switch (type) {
    case "video":
      return <Video className="w-12 h-12 text-gray-400 dark:text-gray-500" />;
    case "podcast":
      return <Mic className="w-12 h-12 text-gray-400 dark:text-gray-500" />;
    case "article":
      return (
        <Newspaper className="w-12 h-12 text-gray-400 dark:text-gray-500" />
      );
    case "partner page":
      return (
        <ExternalLink className="w-12 h-12 text-gray-400 dark:text-gray-500" />
      );
    case "series":
      return <Layers className="w-12 h-12 text-gray-400 dark:text-gray-500" />;
    case "file":
    default:
      return (
        <FileText className="w-12 h-12 text-gray-400 dark:text-gray-500" />
      );
  }
}

export function getResourceIconSmall(
  resourceType: string | null | undefined,
): React.ReactNode {
  const type = resourceType?.toLowerCase();

  switch (type) {
    case "video":
      return <Video className="w-6 h-6 text-gray-400 dark:text-gray-500" />;
    case "podcast":
      return <Mic className="w-6 h-6 text-gray-400 dark:text-gray-500" />;
    case "article":
      return <Newspaper className="w-6 h-6 text-gray-400 dark:text-gray-500" />;
    case "partner page":
      return (
        <ExternalLink className="w-6 h-6 text-gray-400 dark:text-gray-500" />
      );
    case "series":
      return <Layers className="w-6 h-6 text-gray-400 dark:text-gray-500" />;
    case "file":
    default:
      return <FileText className="w-6 h-6 text-gray-400 dark:text-gray-500" />;
  }
}
